import {
  CREATE_QUOTE_START,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAIL,

  GET_QUOTES_START,
  GET_QUOTES_SUCCESS,
  GET_QUOTES_FAIL,

  GET_QUOTE_START,
  GET_QUOTE_SUCCESS,
  GET_QUOTE_FAIL,

  UPDATE_QUOTE_START,
  UPDATE_QUOTE_SUCCESS,
  UPDATE_QUOTE_FAIL,

  CHANGE_QUOTE_STATUS_START,
  CHANGE_QUOTE_STATUS_SUCCESS,
  CHANGE_QUOTE_STATUS_FAIL,

  GENERATE_QUOTE_PDF_START,
  GENERATE_QUOTE_PDF_SUCCESS,
  GENERATE_QUOTE_PDF_FAIL,
} from "./constant";


export const createQuoteStart = data => ({
  type: CREATE_QUOTE_START,
  payload: data,
});

export const createQuoteSuccess = data => ({
  type: CREATE_QUOTE_SUCCESS,
  payload: data,
});

export const createQuoteFail = error => ({
  type: CREATE_QUOTE_FAIL,
  payload: error,
});

export const getQuotesStart = data => ({
  type: GET_QUOTES_START,
  payload: data,
});

export const getQuotesSuccess = data => ({
  type: GET_QUOTES_SUCCESS,
  payload: data,
});

export const getQuotesFail = error => ({
  type: GET_QUOTES_FAIL,
  payload: error,
});


export const getQuoteStart = id => ({
  type: GET_QUOTE_START,
  payload: id,
});

export const getQuoteSuccess = data => ({
  type: GET_QUOTE_SUCCESS,
  payload: data,
});

export const getQuoteFail = error => ({
  type: GET_QUOTE_FAIL,
  payload: error,
});


export const updateQuoteStart = data => ({
  type: UPDATE_QUOTE_START,
  payload: data,
});

export const updateQuoteSuccess = data => ({
  type: UPDATE_QUOTE_SUCCESS,
  payload: data,
});

export const updateQuoteFail = error => ({
  type: UPDATE_QUOTE_FAIL,
  payload: error,
});


export const changeQuoteStatusStart = data => ({
  type: CHANGE_QUOTE_STATUS_START,
  payload: data,
});

export const changeQuoteStatusSuccess = data => ({
  type: CHANGE_QUOTE_STATUS_SUCCESS,
  payload: data,
});

export const changeQuoteStatusFail = error => ({
  type: CHANGE_QUOTE_STATUS_FAIL,
  payload: error,
});



export const generateQuotePdfStart = data => ({
  type: GENERATE_QUOTE_PDF_START,
  payload: data,
});

export const generateQuotePdfSuccess = data => ({
  type: GENERATE_QUOTE_PDF_SUCCESS,
  payload: data,
});

export const generateQuotePdfFail = error => ({
  type: GENERATE_QUOTE_PDF_FAIL,
  payload: error,
});